/**
 * Resolves a hub-relative path (`/settings/logo?v=…`, `/auth/sso/info`)
 * against the hub API origin. Branding and header data answer paths that
 * are relative to the HUB, and the caller may live on another origin (a
 * track frontend, the admin SPA on CloudFront), so a bare `<img src>` or
 * `fetch(path)` would ask the wrong host. With no `hubBaseUrl` the path is
 * returned as is — same-origin deployments and the Vite dev proxy.
 */
export function hubUrl(hubBaseUrl, path) {
    return hubBaseUrl ? `${hubBaseUrl.replace(/\/+$/, '')}${path}` : path;
}
//# sourceMappingURL=hub-url.js.map